import React, {useState} from 'react';
import DataTable from '@preflighttech/preflight-tables';
import { Text, View, Pressable } from 'react-native';
import { RECURRING_SALES_WITH_COUNT, HIDE_RECURRING_SALE } from './queries';
import { useMutation } from '@apollo/client';
import { Link } from 'app/src/utils/routing';
import Filter from 'app/src/elements/Filter';
import { ResetSettings } from 'app/src/elements/Pagination/ResetSettings';
import {
   MainContainer,
   ContentContainer,
   TableContainer,
   PageTitle,
   LinkContainer,
   SubNavContainer
} from '../../../elements';
import moment from 'moment';
import { STATUSES } from './elements';
import Modal from '../../../elements/Modal';
import NewRecurringSale from './new';
import EditRecurringSale from './edit';
import SubNav from '../../../elements/SubNav';

export const DAYS_OF_WEEK = [
  {value: 1, label: 'Monday'},
  {value: 2, label: 'Tuesday'},
  {value: 3, label: 'Wednesday'},
  {value: 4, label: 'Thursday'},
  {value: 5, label: 'Friday'},
  {value: 6, label: 'Saturday'},
  {value: 7, label: 'Sunday'},
]

const inputStyle = {
  marginBottom: '10px'
}

const RecurringSales = (props) => {
  const { nestedSubNav } = props;
  const [refetch, setRefetch] = useState();
  const [clickedRecurringSale, setClickedRecurringSale] = useState();
  const [showAddRecurringSaleModal, setShowAddRecurringSaleModal] = useState(false);
  const [showEditRecurringSaleModal, setShowEditRecurringSaleModal] = useState(false);
  const [filterOptions, setFilterOptions] = useState();
  const [filters, setFilters] = useState({});
  const [settings, setSettings] = useState({});
  const [scopes, setScopes] = useState([])
  const queryVariables = {
    filterColumns: [],
    filterNames: [],
    scopes: [],
  };
  const [hideRecurringSale] = useMutation(
    HIDE_RECURRING_SALE, { onCompleted: refetch }
  )

  const onHide = (recurringSaleId) => {
    hideRecurringSale({ variables: { id: recurringSaleId }});
  };

  const setFilter = (key, value) => {
    const currentFilters = {...filters};
    currentFilters[key] = value;
    setFilters(currentFilters);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryVariables.filterColumns.push(key);
      queryVariables.filterNames.push(value);
    }
  });

  const columns = [
    {
      key: 'name',
      label: 'Sale',
      // width: '45%',
      content: (entry) => {
        return (
          // <View>
          //   <Link to={`/sales/recurring-sales/${entry.entry.id}`}>
          //     {entry.entry.name}
          //   </Link>
          // </View>
          entry.entry.name
        )
      }
    },
    {
      key: 'recurrence',
      label: 'Recurrence',
      content: (entry) => {
        return entry.entry.recurrence
      }
    },
    {
      key: 'frequency',
      label: 'Frequency',
      content: (entry) => {
        return entry.entry.frequency
      }
    },
    {
      key: 'dayOfWeek',
      label: 'Day of Week',
      content: (entry) => {
        return DAYS_OF_WEEK.find(day =>
          entry.entry.dayOfWeek === day.value
        ).label
      }
    },
    {
      key: 'weekOfMonth',
      label: 'Week of Month',
    },
    {
      key: 'preBidOpenAt',
      label: 'PreBid Open At',
      content: (entry) => {
        return moment(entry.entry.preBidOpenAt, 'HH:mm').format('h:mm A')
      }
    },
    {
      key: 'startOn',
      label: 'Start On',
      content: (entry) => {
        return moment(entry.entry.startOn)?.format('M-DD-YY')
      }
    },
    {
      key: 'startAt',
      label: 'Start',
      content: (entry) => {
        return moment(entry.entry.startAt, 'HH:mm').format('h:mm A')
      }
    },
    {
      key: 'endAt',
      label: 'End',
      content: (entry) => {
        return moment(entry.entry.endAt, 'HH:mm').format('h:mm A')
      }
    },
    {
      key: 'functions',
      label: 'Functions',
      // width: '15%',
      // minViewportWidth: 1000,
      content: (entry) => {
        return (
          <LinkContainer>
            <Pressable
              onPress={() => {
                setClickedRecurringSale(entry.entry);
                setShowEditRecurringSaleModal(true)
              }}
              style={{marginLeft: '10px'}}
              key={`recurring-sale-edit-link-${entry.entry.id}`}
                name={`recurring-sale-edit-link-${entry.entry.id}`}
            >
              <Text>
                Edit
              </Text>
            </Pressable>
          </LinkContainer>
        )
      }
    }
  ]

  const buttons = (
    <View style={{display: 'flex', flexDirection: 'row'}}>
      <Filter
        clearFilters={() => {
          setFilters({})
          setShowModal(false)
        }}
        filters={filters}
        setFilters={setFilters}
      >
        <View style={{padding: '20px', justifyContent: 'space-between'}}>
          <Text>Sale Name:</Text>
          <input
            type={'text'}
            name="name"
            onChange={e => setFilter('name', e.target.value)}
            value={filters.name || ''}
            style={inputStyle}
          />
          {/* <Text>Sale Date:</Text>
          <input
            type={'text'}
            name="saleOn"
            onChange={e => setFilter('saleOn', e.target.value)}
            value={filters.saleOn || ''}
            style={inputStyle}
          /> */}
          {/* <Text>Start:</Text>
          <input
            type={'text'}
            name="startAt"
            onChange={e => setFilter('startAt', e.target.value)}
            value={filters.startAt || ''}
            style={inputStyle}
          />
          <Text>End:</Text>
          <input
            type={'text'}
            name="endAt"
            onChange={e => setFilter('endAt', e.target.value)}
            value={filters.endAt || ''}
            style={inputStyle}
          />
          <Text>Pre Bid Open At:</Text>
          <input
            type={'text'}
            name="preBidOpenAt"
            onChange={e => setFilter('preBidOpenAt', e.target.value)}
            value={filters.preBidOpenAt || ''}
            style={inputStyle}
          /> */}
        </View>
      </Filter>
      <ResetSettings />
    </View>
  );

  return (
    <MainContainer>
      {!nestedSubNav &&
        <SubNavContainer>
          <SubNav>
            {getSubNavContents()}
          </SubNav>
        </SubNavContainer>
      }
      <ContentContainer>
        <PageTitle>Recurring Sales</PageTitle>
        <br /><br />
        <TableContainer>
          {nestedSubNav &&
            <TableNavbarContainer>
              <SubNav>
                {getSubNavContents()}
              </SubNav>
            </TableNavbarContainer>
          }
          <DataTable.Gql
            setRefetch={setRefetch}
            query={RECURRING_SALES_WITH_COUNT}
            queryName='recurringSalesWithCount'
            columns={columns}
            buttons={buttons}
            lengthMenu={ [10, 25, 50, 'All'] }
            setSettings={setSettings}
            dataUpdated={data => setFilterOptions(data?.recurringSalesWithCount)}
            htmlTable
            queryVariables={queryVariables}
          />
        </TableContainer>
      </ContentContainer>
      {showEditRecurringSaleModal &&
        <Modal
          showModal={showEditRecurringSaleModal}
          setShowModal={setShowEditRecurringSaleModal}
          modalType={'Edit Recurring Sale'}
          objectName={clickedRecurringSale.name}
          sale={clickedRecurringSale}
        >
          <EditRecurringSale
            setShowModal={setShowEditRecurringSaleModal}
            refetch={refetch}
            recurringSale={clickedRecurringSale}
          />
        </Modal>
      }
    </MainContainer>
  )

  function getSubNavContents() {
    return (
      <View>
        {getLinks()}
      </View>
    )

    function getLinks() {
      return (
        <View>
          <Pressable
            onPress={() => setShowAddRecurringSaleModal(true)}
          >
            <Text>+ Add Recurring Sale</Text>
          </Pressable>
          {showAddRecurringSaleModal &&
            <Modal
              showModal={showAddRecurringSaleModal}
              setShowModal={setShowAddRecurringSaleModal}
              modalType={'Add Recurring Sale'}
            >
              <NewRecurringSale
                setShowModal={setShowAddRecurringSaleModal}
                refetch={refetch}
              />
            </Modal>
          }
        </View>
      )
    }
  }
}

export default RecurringSales;
